import * as React from 'react';
const EndometriosiIcon = ({ primaryColor, secondaryColor, width }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="prefix__Livello_2"
    data-name="Livello 2"
    viewBox="0 0 200 200"
    style={{ width }}
  >
    <defs>
      <style>{`.prefix__cls-1,.prefix__cls-2{stroke:${secondaryColor ||
        '#ffcf38'};fill:none;stroke-linecap:round;stroke-linejoin:round;stroke-width:3.89px}.prefix__cls-2{stroke:${primaryColor ||
        '#282828'}}`}</style>
    </defs>
    <path
      d="M94.43 120.3c.5 3.62 1.27 6.81 2.23 9.34M100 70.36c-8.08 0-14.63 4.52-14.63 15.23 0 4.27 1.05 8.22 2.81 11.42M103.34 129.64c1.75-4.6 2.86-11.39 2.86-18.98v-.09c0-4.73 3.26-9.34 5.57-13.46 1.42-2.54 2.38-5.54 2.72-8.82M62.33 87.2c-2.15 0-4.19-2.74-4.19-6.12h0c.13-3.92 3.68-8.48 11.87-7.89s16.6 3.51 16.6 3.51"
      className="prefix__cls-2"
    />
    <ellipse
      cx={69.2}
      cy={86.72}
      className="prefix__cls-2"
      rx={6.87}
      ry={5.72}
    />
    <path
      d="M137.67 87.2c2.15 0 4.19-2.74 4.19-6.12h0c-.13-3.92-3.68-8.48-11.87-7.89-2.44.18-4.9.56-7.16 1.01"
      className="prefix__cls-2"
    />
    <ellipse
      cx={130.8}
      cy={86.72}
      className="prefix__cls-2"
      rx={6.87}
      ry={5.72}
    />
    <path d="M93.78 90.26s1.04 4.71 3.9 7.17" className="prefix__cls-2" />
    <circle cx={111} cy={76.22} r={7} className="prefix__cls-1" />
    <circle cx={111} cy={76.22} r={1} className="prefix__cls-1" />
    <circle cx={88.03} cy={109.72} r={7} className="prefix__cls-1" />
    <circle cx={88.03} cy={109.72} r={1} className="prefix__cls-1" />
  </svg>
);
export default EndometriosiIcon;
